import { Component, OnInit, forwardRef, Input, EventEmitter, ViewEncapsulation, Output } from '@angular/core';

import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
declare var jQuery: any;
@Component({
    selector: 'dhs-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true
        }
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input() label: any;
  @Input() is_rich_text: boolean;
  @Input() is_label_required: boolean;
  @Input() innerHtml = '';
  @Input() id: any;
  @Input('value') _value = false;
  @Input() className;
  @Output() valueChange = new EventEmitter<any>();
  @Input() options: any;
  @Input() type: any;
  @Input() disabled_: boolean = false;
  @Input() required: boolean = false;
  @Input() showLabel: boolean;
  @Input() question = {};
  propagateChange = (_: any) => { };
  onTouched: any = () => { };
  checkboxData: Array<any> = [];
  mckbClass: string | null = null; // Initialize MultiCkbLayout as null


  constructor() {
  }

    ngOnInit(): void {
    // Check if 'question' exists and if 'question.MultiCkbLayout' exists
    if (this.question && this.question['MultiCkbLayout'] && this.question['MultiCkbLayout']!='none') {
      this.setMultiCkbClass();
    }
  }

  setMultiCkbClass(): void {
    this.mckbClass = 
      this.question['MultiCkbLayout'] === 'four-column' ? 'multi-ckb kx-control col-lg-3 col-md-3 col-sm-12 pl-0 pr-15 fix' :
      this.question['MultiCkbLayout'] === 'three-column' ? 'multi-ckb kx-control col-lg-4 col-md-4 col-sm-12 pl-0 pr-15 fix' :
      this.question['MultiCkbLayout'] === 'two-column' ? 'multi-ckb kx-control col-lg-6 col-md-6 col-sm-12 pl-0 pr-15 fix' :
      this.question['MultiCkbLayout'] === 'one-column' ? 'multi-ckb kx-control col-lg-12 col-md-12 col-sm-12 pl-0 pr-15 fix' :
      'multi-ckb kx-control col-lg-4 col-md-4 col-sm-12 pl-0 pr-15 fix';
  }

  get value(): any {
    return this._value;
  }

  set value(val) {
    if (val && this.question && this.question['type'] && this.question['type'].toLowerCase() == 'array' && typeof (val) == 'string')
      this._value = JSON.parse(val);
    else
      this._value = val;
    if (val)
      this.checkboxData = val;
    this.propagateChange(val);
    this.onTouched();
  }

  writeValue(value) {
    if (value) {
      this.value = value;
    } else {
      this.value = false;
    }
  }
  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  onEnter(e) {
    jQuery(e.target).parent().find('input').trigger('click')
  }
  onSelect(e) {
    //console.log("Type ",this.type," Options ",this.options);
    if (this.options == undefined || this.type == 'Boolean') {
      this.value = e.target.checked;
      this.valueChange.emit(e);
    } else if (this.type == 'String') {
      this.value = e;
      this.valueChange.emit({ "value": e, "options": true });
    } else {
      if (this.checkboxData.indexOf(e) == -1) {
        if (typeof (this.checkboxData) == 'string') {
          var data: any = this.checkboxData;
          this.checkboxData = JSON.parse(data);
          if (!Array.isArray(this.checkboxData)) {
            this.checkboxData = [];
          }
          this.checkboxData.push(e);
        }
        else {
          this.checkboxData.push(e);
        }
      } else {
        if (typeof (this.checkboxData) == 'string') {
          var data: any = this.checkboxData;
          this.checkboxData = JSON.parse(data);
          var index = this.checkboxData.indexOf(e)
          this.checkboxData.splice(index, 1);
        }
        else {
          var index = this.checkboxData.indexOf(e)
          this.checkboxData.splice(index, 1);
        }
      }
      this.value = this.checkboxData;
      console.log("this.checkboxData ", this.checkboxData);
      this.valueChange.emit({ "value": this.checkboxData, "options": true });
    }
  }

  getValue(value) {
    if (typeof (value) == 'string')
      value = value == "false" ? false : value;
    return value;
  }

  checkTypeValue(value) {
    if (typeof value == 'string') {
      return false
    } else {
      return true
    }
  }

  is_present(value, id) {
    return value.includes(id)
  }

}
